import { I18n } from '@calendly/i18n';
import { RadioInput } from '@calendly/ui/components/radio-input';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Statuses } from 'constants/meetings';
import { LeftColumn } from '../left_column';
import { RightColumn } from '../right_column';
import { CheckboxContainer as RadioContainer, LabelContainer, OptionWrapper, StyledLabel } from '../styles';
const radioLeftColumnWrapperIsPhoneCss = "rnok38f";
const radioLeftColumnWrapperCss = "r108gpn4";
const RadioLeftColumnWrapper = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <LeftColumn ref={ref} {...props} className={classNames(radioLeftColumnWrapperCss, {
    [radioLeftColumnWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const radioRightColumnWrapperIsPhoneCss = "r1ru02j6";
const radioRightColumnWrapperCss = "r15kiijv";
const RadioRightColumnWrapper = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <RightColumn ref={ref} {...props} className={classNames(radioRightColumnWrapperCss, {
    [radioRightColumnWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const radioInputLabelCss = "r128m86l";
const RadioInputLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(radioInputLabelCss, props.className)} />;
});
const radioLabelCss = "r2ip5an";
const RadioLabel = forwardRef((props, ref) => <StyledLabel ref={ref} {...props} className={classNames(radioLabelCss, props.className)} />);
const styledRadioInputCss = "skwtwez";
const StyledRadioInput = forwardRef((props, ref) => <RadioInput ref={ref} {...props} className={classNames(styledRadioInputCss, props.className)} />);
export const RadioStatus = ({
  params,
  onChange
}) => {
  const {
    status_ids: statusIds
  } = params;
  const onSelect = value => {
    onChange({
      ...params,
      status_ids: [value]
    });
  };
  const selectedValue = statusIds.length === 0 || statusIds.includes(Statuses.ALL) ? Statuses.ALL : statusIds[0];
  return <>
      <RadioLeftColumnWrapper>
        <LabelContainer>
          <BodyText weight="bold">
            {I18n.t('publisher.meetings.filter_modal.status.label')}
          </BodyText>
        </LabelContainer>
      </RadioLeftColumnWrapper>
      <RadioRightColumnWrapper>
        <RadioContainer>
          <OptionWrapper>
            <RadioInputLabel>
              <StyledRadioInput checked={selectedValue === Statuses.ALL} onChange={() => onSelect(Statuses.ALL)} id="all_status_checkbox" />
              <RadioLabel htmlFor="all_status_checkbox">
                {I18n.t('publisher.dashboard.filters.label.host.all')}
              </RadioLabel>
            </RadioInputLabel>
          </OptionWrapper>
          <OptionWrapper>
            <RadioInputLabel>
              <StyledRadioInput checked={selectedValue === Statuses.ACTIVE} onChange={() => onSelect(Statuses.ACTIVE)} id="default_checkbox" />
              <RadioLabel htmlFor="default_checkbox">
                {I18n.t('publisher.meetings.filter_modal.status.active')}
              </RadioLabel>
            </RadioInputLabel>
          </OptionWrapper>
          <OptionWrapper>
            <RadioInputLabel>
              <StyledRadioInput checked={selectedValue === Statuses.RESCHEDULED} onChange={() => onSelect(Statuses.RESCHEDULED)} id="rescheduled_checkbox" />
              <RadioLabel htmlFor="rescheduled_checkbox">
                {I18n.t('publisher.meetings.filter_modal.status.rescheduled')}
              </RadioLabel>
            </RadioInputLabel>
          </OptionWrapper>
          <OptionWrapper>
            <RadioInputLabel>
              <StyledRadioInput checked={selectedValue === Statuses.CANCELED} onChange={() => onSelect(Statuses.CANCELED)} id="canceled_checkbox" />
              <RadioLabel htmlFor="canceled_checkbox">
                {I18n.t('publisher.meetings.filter_modal.status.canceled')}
              </RadioLabel>
            </RadioInputLabel>
          </OptionWrapper>
          <OptionWrapper>
            <RadioInputLabel>
              <StyledRadioInput checked={selectedValue === Statuses.NO_SHOW} onChange={() => onSelect(Statuses.NO_SHOW)} id="no_show_checkbox" />
              <RadioLabel htmlFor="no_show_checkbox">
                {I18n.t('publisher.meetings.filter_modal.status.no_show')}
              </RadioLabel>
            </RadioInputLabel>
          </OptionWrapper>
        </RadioContainer>
      </RadioRightColumnWrapper>
    </>;
};

require("./radio_status.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./radio_status.js");